import React from 'react';
import SiteHtmlPage from '../components/siteContent/SiteHtmlPage';

const AboutPage = () => (
  <SiteHtmlPage slug="about" wrapperClass="min-h-screen bg-white" />
);

export default AboutPage;
